<template>
  <div class="mb-2">
    <AppFilter
      :filters="filterConfig"
      :filter-submitting="filterSubmitting"
      @filter="handleFilter"
    />
  </div>
</template>
<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { mapGetters } from 'vuex';

import { checkHasRole } from '@/@core/utils/roleAccess';
import { ROLES } from '@/constants/roles';

export default {
  components: {
    AppFilter
  },

  mixins: [helper],
  props: {
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      values: {
        customer_id: ''
      },
      submitting: false,
      files: null,
      formData: null,
      progressShow: false,
      totalProgressValue: 0,
      spinning: false,
      customers: [],
      customerOptions: []
    };
  },

  computed: {
    ...mapGetters({
      pickupStatus: 'app/pickupStatus'
    }),

    customersOptions() {
      return (this.customerOptions || []).map(item => ({
        value: item.id,
        label: item.name
      }));
    },

    statusOptions() {
      return (this.pickupStatus || []).map(item => ({
        value: item.value,
        label: item.text
      }));
    },
    filterConfig() {
      return [
        ...(checkHasRole([ROLES.ADMIN, ROLES.ACCOUNT_ADMIN])
          ? [
              {
                id: 'customer_id',
                label: 'Customer',
                type: 'select',
                options: this.customersOptions,
                placeholder: 'Make a Choice'
              }
            ]
          : []),
        {
          id: 'from_date',
          label: 'Start Date',
          type: 'dateTime',
          placeholder: 'Start Date'
        },
        {
          id: 'to_date',
          label: 'End Date',
          type: 'dateTime',
          placeholder: 'End Date'
        },
        {
          id: 'status',
          label: this.$t('Status'),
          type: 'select',
          options: this.statusOptions,
          placeholder: this.$t('Make a Choice')
        }
      ];
    }
  },

  async created() {
    if (checkHasRole([ROLES.ADMIN, ROLES.ACCOUNT_ADMIN])) {
      this.customerOptions = await this.getCustomers({ paginated: false });
    }
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
      this.values = filters;
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
